 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		0: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"4":"component---cache-caches-gatsby-plugin-offline-app-shell-js","5":"component---src-pages-404-mdx","6":"component---src-pages-about-mdx","7":"component---src-pages-downloads-disbursements-by-month-mdx","8":"component---src-pages-downloads-disbursements-mdx","9":"component---src-pages-downloads-federal-revenue-by-company-mdx","10":"component---src-pages-downloads-index-mdx","11":"component---src-pages-downloads-production-by-month-mdx","12":"component---src-pages-downloads-production-mdx","13":"component---src-pages-downloads-revenue-mdx","14":"component---src-pages-explore-index-mdx","15":"component---src-pages-explore-offshore-regions-alaska-mdx","16":"component---src-pages-explore-offshore-regions-atlantic-mdx","17":"component---src-pages-explore-offshore-regions-gulf-mdx","18":"component---src-pages-explore-offshore-regions-pacific-mdx","19":"component---src-pages-explore-states-ak-mdx","20":"component---src-pages-explore-states-al-mdx","21":"component---src-pages-explore-states-ar-mdx","22":"component---src-pages-explore-states-az-mdx","23":"component---src-pages-explore-states-ca-mdx","24":"component---src-pages-explore-states-co-mdx","25":"component---src-pages-explore-states-fl-mdx","26":"component---src-pages-explore-states-id-mdx","27":"component---src-pages-explore-states-il-mdx","28":"component---src-pages-explore-states-in-mdx","29":"component---src-pages-explore-states-ks-mdx","30":"component---src-pages-explore-states-ky-mdx","31":"component---src-pages-explore-states-la-mdx","32":"component---src-pages-explore-states-md-mdx","33":"component---src-pages-explore-states-mi-mdx","34":"component---src-pages-explore-states-mn-mdx","35":"component---src-pages-explore-states-mo-mdx","36":"component---src-pages-explore-states-ms-mdx","37":"component---src-pages-explore-states-mt-mdx","38":"component---src-pages-explore-states-nc-mdx","39":"component---src-pages-explore-states-nd-mdx","40":"component---src-pages-explore-states-ne-mdx","41":"component---src-pages-explore-states-nm-mdx","42":"component---src-pages-explore-states-nv-mdx","43":"component---src-pages-explore-states-ny-mdx","44":"component---src-pages-explore-states-oh-mdx","45":"component---src-pages-explore-states-ok-mdx","46":"component---src-pages-explore-states-or-mdx","47":"component---src-pages-explore-states-pa-mdx","48":"component---src-pages-explore-states-sc-mdx","49":"component---src-pages-explore-states-sd-mdx","50":"component---src-pages-explore-states-tx-mdx","51":"component---src-pages-explore-states-ut-mdx","52":"component---src-pages-explore-states-va-mdx","53":"component---src-pages-explore-states-wa-mdx","54":"component---src-pages-explore-states-wi-mdx","55":"component---src-pages-explore-states-wv-mdx","56":"component---src-pages-explore-states-wy-mdx","57":"component---src-pages-fact-sheet-mdx","58":"component---src-pages-glossary-mdx","59":"component---src-pages-how-revenue-works-aml-reclamation-program-mdx","60":"component---src-pages-how-revenue-works-audits-and-assurances-mdx","61":"component---src-pages-how-revenue-works-coal-excise-tax-mdx","62":"component---src-pages-how-revenue-works-coal-mdx","63":"component---src-pages-how-revenue-works-disbursements-mdx","64":"component---src-pages-how-revenue-works-federal-laws-mdx","65":"component---src-pages-how-revenue-works-federal-reforms-mdx","66":"component---src-pages-how-revenue-works-gomesa-mdx","67":"component---src-pages-how-revenue-works-hpf-mdx","68":"component---src-pages-how-revenue-works-index-mdx","69":"component---src-pages-how-revenue-works-lwcf-mdx","70":"component---src-pages-how-revenue-works-minerals-mdx","71":"component---src-pages-how-revenue-works-native-american-ownership-governance-mdx","72":"component---src-pages-how-revenue-works-native-american-production-mdx","73":"component---src-pages-how-revenue-works-native-american-revenue-mdx","74":"component---src-pages-how-revenue-works-offshore-oil-gas-mdx","75":"component---src-pages-how-revenue-works-offshore-renewables-mdx","76":"component---src-pages-how-revenue-works-onshore-oil-gas-mdx","77":"component---src-pages-how-revenue-works-onshore-renewables-mdx","78":"component---src-pages-how-revenue-works-ownership-mdx","79":"component---src-pages-how-revenue-works-reclamation-mdx","80":"component---src-pages-how-revenue-works-revenues-mdx","81":"component---src-pages-index-mdx","82":"component---src-pages-patterns-components-index-mdx","83":"component---src-pages-patterns-index-mdx","84":"component---src-pages-patterns-visual-styles-color-mdx","85":"component---src-pages-patterns-visual-styles-iconography-mdx","86":"component---src-pages-patterns-visual-styles-typography-mdx","87":"component---src-pages-query-data-mdx","88":"component---src-pages-search-results-mdx","89":"component---src-pages-vdp-mdx"}[chunkId]||chunkId) + "-" + {"4":"6ee1700e433cfdf3ee02","5":"db42aa89d20df94a2510","6":"7bcd8b62e1867bff1942","7":"36e352ea695a410c5d22","8":"81a7564ba3384d9b151b","9":"afc05b9a6278948e18d5","10":"2fc2704ea0f78685a4b6","11":"c428e85a6de66ad6651d","12":"b74a3284462189e92ec5","13":"2a2c4f16b5dc0b47e3a7","14":"301a3a99495773b37960","15":"2b7607123eeb48deadb8","16":"61b3a4b211920d3b17b0","17":"6ccd9fe51192b9c3c069","18":"d42a5dc23ffb1eec0e41","19":"aae8b06650b9c7613062","20":"c2f9dbb99a7b69cb31ea","21":"3f0ff7c6b9ec4eb56ef3","22":"26cefb28002c500bcb1d","23":"174976a48401acad604e","24":"ba80dac906eee6ac1206","25":"5981c8300e7365aa016a","26":"cec4223267a0a676c9e9","27":"1d6fe97ef83c52c8a091","28":"11422291ce246f328a0b","29":"a7b3855e2d3786c55f17","30":"609bbe59c5cb37b64376","31":"89c6ca5ffeb6493b448b","32":"ac757e1d6bae53d60214","33":"84fcaa3dd3b16aafcffa","34":"1d2142458f5c6a75df25","35":"19ce7575beaac003f265","36":"6e4435f6fa89d512b9c8","37":"ec8e3129a26387323601","38":"31f9bdba846d4a7a2264","39":"5e33bd622401da3b515e","40":"1e73555794fdfd37295f","41":"3c4ef236b7c0db1c3fdb","42":"39ce4df97c2a203cc29a","43":"8fa5abd61b68e588aac7","44":"f02a1c8e0b8e2d52b3ff","45":"7108338d94a4a5f12e70","46":"e252952ffda3217df2e2","47":"7b7bac9098f22bf0d61b","48":"a8256bf1321b0d78edb2","49":"c13b51cd85ebe7279dc4","50":"953b6210af736720c4c3","51":"23e0ea5e971082b94706","52":"69518f98a39340e2c904","53":"56bf5ee3b15fd27adf21","54":"36170193e0c2ab9e94ef","55":"21711ab3d921ede88016","56":"b27e1d35ec803d6c7ccd","57":"9cd926e196a67a474884","58":"64fda6bd54b1071c1e75","59":"3dba72faf8845b029c3c","60":"98b34f0ed2b68e4207b3","61":"bd62e46b980cfac9b111","62":"0ad408c703b2f906dc47","63":"ac03e32563b185eda039","64":"2580d299a85898fb4833","65":"e20d2a4acbe28b083182","66":"3faaf650b873dc8e01e4","67":"b57a1d77e801e3993e2c","68":"458d0385f5d12e1a34a4","69":"2acf2f3056a24252399e","70":"2e6e5543b828ecc96aff","71":"f318fb87c64b5b9dba92","72":"678bf74ec867a871ab6b","73":"765f4ffb068b9ef93edb","74":"ac8da32e65dd0aef29d5","75":"26ce7155b611fa605889","76":"2e77d1ae3bfcaf9dd6a2","77":"074ce111df271eb70066","78":"f01b90753e4bb18136a2","79":"357d6d9d0da4afb977d4","80":"057b82b3301e5a5270ec","81":"03f23ed2fe5ab4ff6d4d","82":"c3203413d01f1d481ff0","83":"c74b868431e60cb1e592","84":"a2c558346c304866fdb9","85":"6f424cf1b56f0bf4e1c2","86":"eccc76c50d4118e8f652","87":"b431571ce62107a3c038","88":"7f0c04e227ee7fa080b0","89":"2beba460c2eebea01512","94":"68bb9f3357844684aa30"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/sites/VDP/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
